import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import instance from "../../api/axios";
import Header from "../Header";
import Footer from "../Footer";
//import axios from "axios";

const Collaborations = () => {
  //const [organizations, setOrganizations] = useState([]);
  //  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const highlightSectors = useMemo(() => {
    return searchParams.get("highlight")?.split(",") || [];
  }, [searchParams]);

  const cardRefs = useRef({});

  // sequential scroll
  useEffect(() => {
  if (highlightSectors.length > 0) {
    let index = 0;

    const scrollNext = () => {
      if (index < highlightSectors.length) {
        const key = highlightSectors[index];
        const el = cardRefs.current[key];
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        index++;
        setTimeout(scrollNext, 800);
      }
    };

    // Delay start so refs get attached
    const timer = setTimeout(scrollNext, 300);
    return () => clearTimeout(timer);
  }
}, [highlightSectors]);


  // Single handler for navigation on category card click
  const handleSectorClick = useCallback(
    (route) => {
      navigate(route);
    },
    [navigate]
  );

  // Categories array for mapping cards
  const categories = [
    {
      key: "Education",
      label: "Education",
      icon: "/graduationcapgraduationcapeducation.svg",
      route: "/EducationCollaboration",
    },
    {
      key: "HealthCare",
      label: "HealthCare",
      icon: "/signcrosssquarehealthsignmedicalsymbolhospitalcrosssquare.svg",
      route: "/HealthcareCollaboration",
    },
    {
      key: "Logistics",
      label: "Logistics",
      icon: "/ambulancecaremergencyhealthmedicalambulance.svg",
      route: "/LogisticsCollaboration",
    },
    {
      key: "Agriculture",
      label: "Agriculture",
      icon: "/beachislandwavesoutdoorrecreationtreebeachpalmwavewatertravelplaces.svg",
      route: "/AgricultureCollaboration",
    },
    {
      key: "AnimalHusbandry",
      label: "Animal Husbandry",
      icon: "/petsallowedtravelwayfinderpetsallowed.svg",
      route: "/AnimalhusbandryCollaboration",
    },
    {
      key: "InformationTechnology",
      label: "Information Technology",
      icon: "/desktopchecksuccessapprovedevicedisplaydesktopcomputer.svg",
      route: "/InformationTechnologyCollaboration",
    },
    {
      key: "Insurance",
      label: "Insurance",
      icon: "/insurancehandhealthmedicalinsurancehandcross.svg",
      route: "/InsuranceCollaboration",
    },
  ];

  // Enquiry form modal state and handlers (unchanged)
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    MobileNo: "",
    InterestedField: "",
  });
  const [errors, setErrors] = useState({});

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.Name.trim()) newErrors.Name = "Name is required";
    if (!formData.Email.trim()) newErrors.Email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.Email)) newErrors.Email = "Invalid email format";
    if (!formData.MobileNo.trim()) newErrors.MobileNo = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.MobileNo)) newErrors.MobileNo = "Enter a valid 10-digit mobile number";
    if (!formData.InterestedField) newErrors.InterestedField = "Please select a field of interest";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Your existing handleSubmit can remain the same (replace UploadEmailPopup with your actual dispatch if any)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const res = await instance.post("/api/enquiry", formData);
      console.log("response ,", res.data);

      if (res.data.success) {
        toast.success("✅Enquiry sent successfully!,InnoHubTeam Will Contact You Soon");
        closeModal(); // if you want to close after success
      } else {
        toast.error("❌ Failed to send enquiry");
      }
    } catch (err) {
      toast.error("⚠️ Error sending enquiry");
      console.error(err);
    }
  };

  return (
    <div className="relative bg-gray text-left text-xl text-cold-grey-white font-poppins w-full px-0 flex flex-col items-start justify-start min-h-screen overflow-x-hidden overflow-y-auto">
      <div className="absolute flex mx-auto top-0 right-0 left-0 h-[95px] overflow-hidden">
        <Header />
      </div>

      <section className="text-white flex flex-col items-center body-font md:mx-[95px] lg:mx-0 mt-40 mb-12">
        <div className="container px-12 py-2 text-left">
          <div className="w-full flex justify-center mb-3">
            <img
              className="max-w-[700px] h-auto object-cover mx-auto"
              alt="Collaborations"
              src="/Group 143726497.png"
            />
          </div>

          <div className="container mx-auto mt-10 font-poppins">
            <b className="text-29xl md:text-29xl m-5 font-bold text-white flex content-center items-center">
              Collaborations
            </b>
            <p className="mb-5 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl md:mb-5 lg:mb-5 xl:mb-5 lg:text-base transform scale-120">
              The InnoHub Research Centre, established in 2017 as SNIPE TECH PVT LTD Collaboration is the cornerstone of innovation at Innohub Research Center. We strive to create a dynamic environment where academics, industry professionals, government agencies, and community organizations can come together to address pressing global challenges through interdisciplinary research and shared expertise.
            </p>

            <p className="mb-10 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl md:mb-5 lg:mb-5 xl:mb-5 lg:text-base transform scale-120">
              Over the years, our commitment to excellence has attracted top-tier Our collaborative initiatives empower researchers and stakeholders to exchange ideas, combine resources, and drive impactful solutions in fields mentioned below.
            </p>
          </div>
        </div>

        {/* Cards Container */}
        <div className="flex flex-wrap md:flex-nowrap justify-center gap-2 mx-auto font-poppins">
          {categories.map(({ key, label, icon, route }) => (
            <div
              key={key}
              ref={(el) => (cardRefs.current[key] = el)}
              className={`w-[100px] h-[100px] bg-blue rounded-lg cursor-pointer hover:scale-105 flex flex-col items-center justify-center ${highlightSectors.includes(key) ? "ring ring-yellow-400 ring-offset-2" : ""
                }`}
              onClick={() => handleSectorClick(route)}
            >
              <img className="w-[40px] h-[40px] mb-1" alt={label} src={icon} />
              <b className="text-white text-xs text-center">{label}</b>
            </div>
          ))}
        </div>

        {/* Enquiry Form Section */}
        <div className="container mx-auto mt-10 font-poppins mb-3">
          <b className="text-29xl md:text-29xl m-5 font-bold text-white flex content-center items-center">
            Opportunities to Collaborate:
          </b>

          <div className="flex flex-col items-center mt-0 ml-auto w-[350px]">
            <div className="flex justify-start">
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  openModal();
                }}
                className="mr-[1600px] text-white text-xl font-bold underline cursor-pointer whitespace-nowrap"
              >
                Enquiry Form for New Collaboration Opportunity
              </a>
            </div>

            {isOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-purple-700 text-white p-6 rounded-2xl w-[600px]">
                  <form
                    onSubmit={handleSubmit}
                    className="w-300px bg-color flex-col items-center p-6 rounded-xl shadow-lg"
                  >
                    <h2 className="text-white text-2xl font-semibold text-center mb-4">
                      Enquiry Form for New Collaboration Opportunity
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                      <div>
                        <label className="block mb-2 font-poppins font-bold text-white">
                          Name*
                        </label>
                        <input
                          type="text"
                          name="Name"
                          value={formData.Name}
                          onChange={handleChange}
                          placeholder="Enter Name"
                          className="w-full h-[45px] rounded px-2 text-black"
                        />
                        {errors.Name && (
                          <p className="text-red-500 text-sm">{errors.Name}</p>
                        )}
                      </div>

                      <div>
                        <label className="block mb-2 font-poppins font-bold text-white">
                          Email*
                        </label>
                        <input
                          type="email"
                          name="Email"
                          value={formData.Email}
                          onChange={handleChange}
                          placeholder="Enter your Email"
                          className="w-full h-[45px] rounded px-2 text-black"
                        />
                        {errors.Email && (
                          <p className="text-red-500 text-sm">{errors.Email}</p>
                        )}
                      </div>

                      <div>
                        <label className="block mb-2 font-poppins font-bold text-white">
                          Mobile Number*
                        </label>
                        <input
                          type="text"
                          name="MobileNo"
                          value={formData.MobileNo}
                          onChange={handleChange}
                          placeholder="Enter Mobile Number"
                          className="w-full h-[45px] rounded px-2 text-black"
                        />
                        {errors.MobileNo && (
                          <p className="text-red-500 text-sm">{errors.MobileNo}</p>
                        )}
                      </div>

                      <div>
                        <label className="block mb-2 font-poppins font-bold text-white">
                          Interested Field:*
                        </label>
                        <select
                          name="InterestedField"
                          value={formData.InterestedField}
                          onChange={handleChange}
                          className="w-full h-[45px] rounded px-2 pr-8 text-black"
                        >
                          <option value="">Select Interested Field</option>
                          <option value="Education">Education</option>
                          <option value="HealthCare">HealthCare</option>
                          <option value="Logistics">Logistics</option>
                          <option value="Agriculture">Agriculture</option>
                          <option value="AnimalHusbandry">Animal Husbandry</option>
                          <option value="InformationTechnology">
                            Information Technology
                          </option>
                          <option value="Insurance">Insurance</option>
                        </select>
                        {errors.InterestedField && (
                          <p className="text-red-500 text-sm">
                            {errors.InterestedField}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="flex justify-center mt-6">
                      <button
                        type="button"
                        onClick={closeModal}
                        className="bg-black text-white py-2 px-6 rounded-lg mr-4"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-black text-white py-2 px-6 rounded-lg"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>

          <ul className="mb-[0px] m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl  lg:text-base transform scale-120 ">
            <li className="p-1">
              Research Partnerships: Work with our teams on pioneering research
              projects.
            </li>
            <li className="p-1">
              Joint Funding Applications: Collaborate on national and
              international grants for impactful
            </li>
            <li className="p-1">
              Student and Faculty Exchanges: Facilitate skill and knowledge
              transfer through academic exchange programs.
            </li>
            <li className="p-1 ">
              Workshops and Seminars: Co-host events to disseminate and develop
              cutting-edge ideas.
            </li>
            <li className="p-1">
              Joint Research Projects: Collaborate on innovative research
              initiatives that address complex scientific, societal, and
              industrial challenges.
            </li>
            <li className="p-1">
              Knowledge Exchange: Participate in workshops, conferences, and
              seminars to share insights and ideas.
            </li>
            <li className="p-1">
              Technology Transfer: Work with us to bring research findings and
              innovations to real-world applications.
            </li>
            <li className="p-1">
              Student and Researcher Development: Co-develop training programs,
              internships, and exchange opportunities for students and
              researchers.
            </li>
            <li className="p-1">
              exchange opportunities for students and researchers.Community
              Engagement: Partner with us to make research outcomes accessible
              and impactful for communities.
            </li>
          </ul>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Collaborations;
